<template>
  <div class="cdwritobtawh">
    <sec-title
      Text="你能获得什么?"
      desc-text="专业合规，降低90%常见风险的专业合同"
      class="text_center"
    />
    <div class="obwtlist between">
      <div class="obwtitem">
        <div class="top">量身定制</div>
        <div class="bom">
          <div class="covic">
            <img src="../../../assets/contmodeldet/obtawhicon1.png" alt="" />
          </div>
          <div class="text">
            针对您的诉求和目的，及时点出合同关键问题和风险，表达您的法律主张
          </div>
        </div>
      </div>

      <div class="obwtitem">
        <div class="top">量身定制</div>
        <div class="bom">
          <div class="covic">
            <img src="../../../assets/contmodeldet/obtawhicon2.png" alt="" />
          </div>
          <div class="text">
            结合实务设计关于钱款、责任、纠纷解决等关键条款，有效保护您的权益
          </div>
        </div>
      </div>

      <div class="obwtitem">
        <div class="top">深谋远虑</div>
        <div class="bom">
          <div class="covic">
            <img src="../../../assets/contmodeldet/obtawhicon3.png" alt="" />
          </div>
          <div class="text">
            重点提示可能对您产生的风险，输出有效的应对策略，全面规避您的风险
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
export default {
  components: {
    secTitle,
  },
};
</script>
<style lang="scss" scoped>
.cdwritobtawh {
  width: 1200px;
  padding: 50px 0;
  margin: 0 auto;
  .obwtlist {
    .obwtitem {
      width: 368px;
      height: 388px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
      .top {
        width: 368px;
        height: 159px;
        background: linear-gradient(207deg, #0465ea, #3285f7);
        padding-top: 45px;
        text-align: center;
        font-size: 30px;
        color: #ffffff;
      }
      .bom {
        text-align: center;
        padding: 0 48px;
        .covic {
          transform: translateY(-50%);
          img {
            width: 92px;
          }
        }
        .text {
          position: relative;
          top: -15px;
          font-size: 18px;
          color: #666666;
          line-height: 33px;
        }
      }
    }
  }
}
</style>